export default "__VITE_ASSET__DSmPcWKW__"